import React from 'react';

export interface SearchableItem {
    id: string | number;
    code: string;
    description: string;
}
interface TypeAheadProps {
    shouldDisplay: boolean;
    value: string;
    onSelect: (x: SearchableItem) => void;
    searchFunction: (x: string) => Promise<SearchableItem[]>;
}
function TypeAhead({ shouldDisplay, value, onSelect, searchFunction }: TypeAheadProps) {
    const servicesCall = React.useRef<ReturnType<typeof setTimeout>>();
    const [displayList, setList] = React.useState<SearchableItem[]>([]);

    React.useEffect(() => {
        if (servicesCall.current) clearTimeout(servicesCall.current);
        if (value.trim() === '') {
            setList([]);
        } else {
            servicesCall.current = setTimeout(async () => {
                const result = await searchFunction(value);
                setList(result);
            }, 200);
        }
        return () => {
            if (servicesCall.current) clearTimeout(servicesCall.current);
        };
    }, [searchFunction, value]);

    React.useEffect(() => {
        setList([]);
    }, [shouldDisplay]);

    return shouldDisplay && displayList.length > 0 ? (
        <div className="typeahead-wrapper">
            {displayList.map((x) => (
                <div key={x.id} className="typeahead-item">
                    <button type="button" onClick={() => onSelect(x)}>
                        {x.code} - {x.description}
                    </button>
                </div>
            ))}
        </div>
    ) : null;
}

export { TypeAhead };
